import RainbowCustomButton from "../../Helpers/Rainbow/CustomButton";

export default function UserBalance() {
  return (
    <div className="flex user-balance cursor-pointer md:w-[180px] w-[130px] h-[48px]  items-center rounded-full relative  bg-purple pr-1.5 pl-1.5">
      <RainbowCustomButton />
    </div>
  );
}
